import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MainService } from 'src/app/services/main.service';

import { CartService } from 'src/app/services/cart.service';
import { CartModelServer } from "../../models/cart.model";
// import { ProductModelServer } from "../../models/product.model";
// import { Category, CategoryModelServer } from 'src/app/models/category.model';
import { ProductService } from 'src/app/services/product.service';
import { CategoryService } from 'src/app/services/category.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

import { ModalService } from 'src/app/services/modal.service';

import { debounceTime, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isLoggedIn = false;
  username: string | null = null;
   isUserDropdownOpen = false;
isLoginModalOpen = false;
  loginForm!: FormGroup;
  registerForm!: FormGroup;
  loginError: string = '';
  loginSuccess: string = '';
  registerError: string = '';
  registerSuccess: string = '';

  otherimageBaseUrl = environment.otherimageBaseUrl;
  imageBaseUrl = environment.imageBaseUrl;
  
  cartData: CartModelServer;
  cartTotal: Number;
  // products: ProductModelServer[] = [];
  menus: any[] = [];
  categories: any[] = [];
  menuList: any[] = [];

  isSticky: boolean = false;
  showScrollToTop = false;

  searchQuery = '';
  searchResults: any[] = [];
  private searchSubject = new Subject<string>();
  
  constructor(private modalService: ModalService,
    private productService: ProductService,
    public cartService: CartService,
     private categoryService: CategoryService,
     private router: Router,
     private fb: FormBuilder, private mainService: MainService
  ) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isSticky = window.pageYOffset > 100;

    const scrollY = window.pageYOffset;
    this.isSticky = scrollY > 100;
    this.showScrollToTop = scrollY > 400;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  ngOnInit(): void {
     this.modalService.loginModal$.subscribe(() => {
      this.openLoginModal();
    });
    
    this.checkLoginStatus();
    this.cartService.cartTotal$.subscribe(total => {
      this.cartTotal = total;
    });

    this.cartService.cartDataObs$.subscribe(data => this.cartData = data);


      // Fetch categories
          this.categoryService.getAllCategories().subscribe((data: any[]) => {
          this.categories = data.slice(0,6);
          });


        // Fetch menu with submenus
        this.categoryService.getMenuWithSubmenus().subscribe(data => {
          this.menuList = data;
        });

        // search

      this.searchSubject.pipe(
        debounceTime(300),
        switchMap(query => this.productService.searchProducts(query))
      ).subscribe((results: any[]) => {
        this.searchResults = results;
      });
        

      this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });

    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      fname: [''],
      lname: [''],
      username: [''],
    });

  }

   onSearchChange(query: string): void {
    this.searchQuery = query;
    this.searchSubject.next(query);

     // Also update the URL instantly
    //  this.router.navigate([], {
    //    queryParams: { q: query.trim() },
    //    queryParamsHandling: 'merge',
    //    replaceUrl: true
    //  });
    
     if (this.router.url !== '/') {
       this.router.navigate(['/'], { queryParams: { q: query } });
     } else {
       // If already on homepage, just update query params
       this.router.navigate([], {
         queryParams: { q: query },
         queryParamsHandling: 'merge'
       });
     }
  }

  ngAfterViewInit() {
  const burger = document.querySelector('.mfn-header-menu-toggle');
  const sidebar = document.querySelector('.mfn-header-tmpl-menu-sidebar');
  const overlay = document.createElement('div');
  const searchicon = document.querySelector('.mfn-searchbar-toggle');
  overlay.classList.add('menu-overlay');
  document.body.appendChild(overlay);

  burger?.addEventListener('click', (e) => {
    e.preventDefault();
    sidebar?.classList.add('open');
    overlay.classList.add('active');
    searchicon?.classList.add('opacity-zero');
    
  });

  const closeBtn = sidebar?.querySelector('.mfn-close-icon');
  closeBtn?.addEventListener('click', () => {
    sidebar?.classList.remove('open');
    overlay.classList.remove('active');
    searchicon?.classList.remove('opacity-zero');
  });

  overlay.addEventListener('click', () => {
    sidebar?.classList.remove('open');
    overlay.classList.remove('active');
    searchicon?.classList.remove('opacity-zero');
  });
}



  selectCategory(id: Number) {
    this.router.navigate(['category', id]).then();
  }

// Convert slug to Title: 'accent-chairs' → 'Accent Chairs'
  getSlug(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }


  onLogin(): void {
    if (this.loginForm.invalid) return;

    this.mainService.login(this.loginForm.value).subscribe({
      next: (res) => {
        this.loginSuccess = res.message;
        this.checkLoginStatus();
        this.loginError = '';
        setTimeout(() => {
          this.closeLoginModal();
          this.loginForm.reset();
        }, 1500);
      },
      error: (err) => {
        this.loginError = err?.error?.message || 'Login failed';
      },
    });
  }

  onRegister(): void {
    if (this.registerForm.invalid) return;

    const data = {
      email: this.registerForm.value.email,
      passwords: { password: this.registerForm.value.password },
      fname: this.registerForm.value.fname,
      lname: this.registerForm.value.lname,
      username: this.registerForm.value.username,
    };

    this.mainService.register(data).subscribe({
      next: (res) => {
        this.registerSuccess = res.message;
        this.registerError = '';
        setTimeout(() => {
          this.closeRegisterModal();
        }, 1500);
      },
      error: (err) => {
        this.registerError =
          err?.error?.errors?.[0]?.msg || err?.error?.message || 'Registration failed';
      },
    });
  }



  checkLoginStatus(): void {
    const token = localStorage.getItem('token');
    if (token) {
      try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      this.username = payload?.username || null;
      this.isLoggedIn = true;
       } catch (error) {
        this.username = null;
        this.isLoggedIn = false;
      }
    }
  }

  logout(): void {
    this.mainService.logout();
    this.isLoggedIn = false;
    this.username = null;
    this.isUserDropdownOpen = false;
    this.router.navigate(['/']); // Redirect to homepage or login
  }

  toggleUserDropdown(): void {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }

  openLoginModal(): void {
    document.querySelector('.mfn-header-modal-login')?.classList.add('active');
    this.isUserDropdownOpen = false;
  }

  closeLoginModal(): void {
  document.querySelector('.mfn-header-modal-login')?.classList.remove('active');
}

  openRegisterModal(): void {
    document.querySelector('.mfn-header-modal-register')?.classList.add('active');
    this.isUserDropdownOpen = false;
  }

  closeRegisterModal(): void {
    document.querySelector('.mfn-header-modal-register')?.classList.remove('active');
  }

  

switchToRegister(): void {
  document.querySelector('.mfn-header-modal-login')?.classList.remove('active');
  document.querySelector('.mfn-header-modal-register')?.classList.add('active');
}

switchToLogin(): void {
  document.querySelector('.mfn-header-modal-register')?.classList.remove('active');
  document.querySelector('.mfn-header-modal-login')?.classList.add('active');
}


}
